export default __webpack_public_path__ + "static/media/problema-05.eaffa584.webp";